var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9079547 5.6782201l-11.252567.0057555 3.5456672-3.5534783c.1736245-.1734874.2688645-.408504.2688645-.6551687 0-.2466646-.09524-.4800368-.2688645-.6539353L7.6493483.2694126C7.4758609.0959251 7.2446813 0 6.9981537 0c-.2466647 0-.4779813.09524-.6514687.2687274L.2687311 6.3461331c-.1741726.1741727-.2694126.4061745-.2687347.6529762-.0006779.248172.0945621.4803108.2687347.6542094l6.0779539 6.0779539C6.5201724 13.904623 6.751352 14 6.9981537 14c.2465276 0 .4777072-.095514.6511946-.2687274l.5517066-.5519807c.1736245-.1732134.2688645-.40453.2688645-.6511946 0-.2465277-.09524-.4656481-.2688645-.6389985L4.6153732 8.3157503H15.920562c.5079921 0 .934859-.4378297.934859-.9455478v-.7806936c0-.507718-.4394742-.9112888-.9474663-.9112888z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f3a0b30a1be1476032a27c9d63dd7e75.svg";
export { ForwardRef as ReactComponent };